import styled from 'styled-components';
import SectionContainer from '../../components/SectionContainer';

export const CheckoutContainer = styled(SectionContainer)`
  flex-grow: 1;
  padding-top: 30px;
  padding-bottom: 55px;
  
  @media(min-width: 768px) {
    flex-wrap: nowrap;
    padding-top: 50px;
    padding-bottom: 80px;
  }
  
  @media(min-width: 1024px) {
    padding-top: 70px;
    padding-bottom: 75px;
  }
`;

export const Column = styled.div`
  width: 100%;
  
  @media(min-width: 768px) {
    &:first-child {
      flex-grow: 1;
    }
    
    &:last-child {
      width: 340px;
      flex-shrink: 0;
      margin-left: 30px;
    }
  }
  
  @media(min-width: 1024px) {    
    &:last-child {
      margin-left: 120px;
    }
  }
`;

export const PageHeading = styled.div`
  margin-bottom: 15px;
  
  @media(min-width: 768px) {
    margin-bottom: 25px;
  }
  
  @media(min-width: 1024px) {
    margin-bottom: 20px;
  }
`;

export const Heading = styled.h2`
  margin: 0;
  margin-bottom: 15px;
  padding: 0;
  
  font-size: 30px;
  line-height: 1;
  
  span {
    display: none;
    
    color: ${({ theme }) => theme.blue};
  }
  
  @media(min-width: 768px) {
    margin-bottom: 30px;
    font-size: 36px;
    
    span {
      display: inline-block;
    }
  }
`;

export const SubHeading = styled.p`
  margin: 0;
  padding: 0;
  
  font-weight: 700;
  font-size: 22px;
  line-height: 1;
  
  @media(min-width: 768px) {
    margin-bottom: 15px;
    
    font-size: 36px;
  }
`;
